import React from 'react';
import './collectionIntro.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { CollectionSimpleCard } from '../../UI/Cards/Collection/Simple/CollectionSimpleCard';
import { IBlock, ILabel } from '../../../utils/types/contentful';

export interface CollectionIntroProps {
  cards: IBlock;
  label: ILabel;
  subLabel: ILabel;
}

export const CollectionIntroItems = ({ cards }) =>
  cards.items.map((card, index) => <CollectionSimpleCard {...card} />);

export const CollectionIntro = ({
  cards,
  label,
  subLabel,
}: CollectionIntroProps) => (
  <div className='w-full py-8 flex flex-col lg:flex-row'>
    <div className='w-full lg:pr-8 lg:w-1/4 mb-10 lg:mb-0'>
      <div className='mb-4'>
        <Label
          {...label}
          color={{ classname: 'gray-800' }}
          size='3xl'
          weight='bold'
        />
      </div>
      <Label
        {...subLabel}
        size='base'
      />
    </div>
    <div className='w-full lg:w-3/4 grid grid-cols-2  md:grid-cols-4 gap-5'>
      <CollectionIntroItems cards={cards} />
    </div>
  </div>
);
